<template>
  <div class="coupon__list">
    <bsi-coupon-list-item :item="coupon" :key="coupon.cartItemId" v-for="coupon in items" />
  </div>
</template>

<script>
import BsiCouponListItem from '@/modules/cart/components/Coupons/BsiCouponListItem'

export default {
  name: 'BsiCouponList',
  props: ['items'],
  components: {
    BsiCouponListItem
  }
}
</script>
